/* eslint-disable prettier/prettier */ /**
 * Do not edit directly
 * Generated on Tue, 30 Jul 2024 07:51:57 GMT
 */
const Elevation = "0px 1px 3px 0px #00000066";
const SpacingXs = "4px";
const SpacingS = "8px";
const SpacingM = "16px";
const SpacingL = "24px";
const SpacingXl = "32px";
const SpacingXxl = "40px";
const SpacingXxxl = "48px";
const SpacingXxxxl = "56px";
const CornerRadiusS = "4px";
const CornerRadiusM = "8px";
const CornerRadiusL = "16px";
const CornerRadiusXl = "24px";
const CornerRadiusNone = "0px";
const CornerRadiusInfinite = "9999px";

export { CornerRadiusInfinite, CornerRadiusL, CornerRadiusM, CornerRadiusNone, CornerRadiusS, CornerRadiusXl, Elevation, SpacingL, SpacingM, SpacingS, SpacingXl, SpacingXs, SpacingXxl, SpacingXxxl, SpacingXxxxl };
